import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input } from 'reactstrap';

type EditarDetalleModalProps = {
  isOpen: boolean;
  toggle: () => void;
  label?: string;
  value?: string;
  onChange?: (v: string) => void;
  onSave: () => void;
  detalleProperty?: any;
  setDetalleProperty?: (p: any) => void;
};

const EditPricelModal: React.FC<EditarDetalleModalProps> = ({
  isOpen,
  toggle,
  label,
  value,
  onChange,
  onSave,
  detalleProperty,
  setDetalleProperty,
}) => (
  <Modal isOpen={isOpen} toggle={toggle}>
    <ModalHeader toggle={toggle}>
      {label || 'Editar propiedad'}
    </ModalHeader>
    <ModalBody>
      {label && onChange && (
        <FormGroup>
          <Label>{label}</Label>
          <Input
            value={value}
            onChange={e => onChange(e.target.value)}
            autoFocus
          />
        </FormGroup>
      )}
      
      {detalleProperty && setDetalleProperty && (
        <>
          {/* Venta */}
          <div style={{ display: 'flex', gap: 16 }}>
            <FormGroup style={{ flex: 1 }}>
              <Label for="sale_price">Precio de Venta</Label>
              <Input
                id="sale_price"
                type="number"
                value={detalleProperty.sale_price ?? ''}
                onChange={e =>
                  setDetalleProperty({ ...detalleProperty, sale_price: e.target.value })
                }
              />
            </FormGroup>
            <FormGroup style={{ flex: 1 }}>
              <Label for="sale_min_price">Precio mínimo venta</Label>
              <Input
                id="sale_min_price"
                type="number"
                value={detalleProperty.sale_min_price ?? ''}
                onChange={e =>
                  setDetalleProperty({ ...detalleProperty, sale_min_price: e.target.value })
                }
              />
            </FormGroup>
          </div>
          {/* Renta */}
          <div style={{ display: 'flex', gap: 16 }}>
            <FormGroup style={{ flex: 1 }}>
              <Label for="price">Precio de Renta</Label>
              <Input
                id="price"
                type="number"
                value={detalleProperty.price ?? ''}
                onChange={e =>
                  setDetalleProperty({ ...detalleProperty, price: e.target.value })
                }
              />
            </FormGroup>
            <FormGroup style={{ flex: 1 }}>
              <Label for="offer_min_price">Precio mínimo renta</Label>
              <Input
                id="offer_min_price"
                type="number"
                value={detalleProperty.offer_min_price ?? ''}
                onChange={e =>
                  setDetalleProperty({ ...detalleProperty, offer_min_price: e.target.value })
                }
              />
            </FormGroup>
          </div>
        </>
      )}
    </ModalBody>
    <ModalFooter>
      <Button color="primary" onClick={onSave}>
        Guardar
      </Button>
      <Button color="secondary" onClick={toggle}>
        Cancelar
      </Button>
    </ModalFooter>
  </Modal>
);

export default EditPricelModal;